export const transformUnderscoredData = data => {
  const dataSegments = data.split('_')
  const spacedData = dataSegments.join(' ')
  return spacedData
}

export const handleData = data => (data ? data : '')
